import React, { useEffect, useRef, useState } from "react";
import InputClearIcon from "@/assets/common/ic_input_clear.svg?react";

interface InputWithClearProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  onMyChange: (value: string) => void;
  allowClear?: boolean;
  limitPattern?: RegExp;
  wapperClassName?: string;
}

const InputWithClear: React.FC<InputWithClearProps> = ({
  onMyChange,
  allowClear,
  limitPattern,
  wapperClassName,
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState(props.value || "");
  const [isComposition, setIsComposition] = useState(false);

  useEffect(() => {
    setValue(props.value || '');
  }, [props.value])


  const handleClear = () => {
    if (!inputRef.current) return;
    inputRef.current.value = "";
    innerChange("");
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setValue(value);
    if (!isComposition) {
      innerChange(value);
    }
  }

  const innerChange = (value: string) => {
    const _value = value.replace(limitPattern as RegExp, "");
    if (inputRef.current) {
      inputRef.current.value = _value;
    }
    setValue(_value);
    onMyChange(_value);
    return _value;
  }

  const handleCompositionStart = () => {
    setIsComposition(true);
  }

  const handleCompositionEnd = (e: React.CompositionEvent<HTMLInputElement>) => {
    setIsComposition(false);
    const target = e.target as HTMLInputElement;
    innerChange(target.value);
  }

  return (
    <div className={`relative inline-block ${wapperClassName || ''}`}>
      <input
        ref={inputRef}
        onCompositionStart={handleCompositionStart}
        onCompositionEnd={handleCompositionEnd}
        {...props}
        onChange={handleChange}
        value={value}
      />
      {allowClear && inputRef.current?.value && (
        <div
          onClick={handleClear}
          className="absolute right-4 top-50% translate-y--50% w-4 h-4 cursor-pointer"
        >
          <InputClearIcon className="w-4 h-4" />
        </div>
      )}
    </div>
  );
};

export default InputWithClear;
